import React, { useMemo, useRef, useState } from "react"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { useNavigate } from "react-router-dom"
import { ArrowDown } from "react-feather"
import { ROUTES } from "../../routes"
import { motion, useMotionValueEvent, useScroll } from "framer-motion"
import { APP_LOCALE, getLanguage, useLanguage } from "@languages/index"
import classNames from "classnames"
import { LOCALES } from "constants/locales"
import DOMAIN from "constants/domain"
import ButtonCommonJapan from "@components/buttonCommonJapan/index"



const IMG_HEADER = "/assets/images/seeding/jp/seeding-intro-header.webp"

const IMG_SEEDING_INTRO_01 = "/assets/images/seeding/jp/seeding-intro-01.webp";
const IMG_SEEDING_INTRO_02 = "/assets/images/seeding/jp/seeding-intro-02.webp";
const IMG_SEEDING_INTRO_03 = "/assets/images/seeding/jp/seeding-intro-03.webp";
const IMG_SEEDING_INTRO_04 = "/assets/images/seeding/jp/seeding-intro-04.webp";
const IMG_SEEDING_INTRO_05 = "/assets/images/seeding/jp/seeding-intro-05.webp";
const IMG_SEEDING_INTRO_06 = "/assets/images/seeding/jp/seeding-intro-06.webp";

const IMG_SEEDING_INTRO_01_M = "/assets/images/seeding/jp/seeding-intro-01-m.webp";
const IMG_SEEDING_INTRO_02_M = "/assets/images/seeding/jp/seeding-intro-02-m.webp";
const IMG_SEEDING_INTRO_03_M = "/assets/images/seeding/jp/seeding-intro-03-m.webp";
const IMG_SEEDING_INTRO_04_M = "/assets/images/seeding/jp/seeding-intro-04-m.webp";
const IMG_SEEDING_INTRO_05_M = "/assets/images/seeding/jp/seeding-intro-05-m.webp";
const IMG_SEEDING_INTRO_06_M = "/assets/images/seeding/jp/seeding-intro-06-m.webp";



const CampaignIntroJapan = (props: any) => {

  const navigate = useNavigate()
  const [showFloatingButtons, setShowFloatingButtons] = useState(false)
  const scrollContainerRef = useRef(null)
  const { scrollY } = useScroll({
    container: scrollContainerRef,
  })

  const languageCode = getLanguage()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }

  useMotionValueEvent(scrollY, "change", (latest) => {
    const nextState = latest > 740 ? true : false
    if (showFloatingButtons != nextState) {
      setShowFloatingButtons(nextState)
    }
  })

  const footerAnimVariants = {
    hidden: { opacity: 0, y: 300 },
    show: { opacity: 1, y: 0 },
  }

  const openPDF = () => {
    let url = "https://" + DOMAIN.BASE.URL + "/intro/seeding"
    window.open(url, "_blank")
  }


  const CLASS_MAP = {
    sectorContainerBase: "mx-auto px-[16px] md:px-[20px] w-full md:w-[1240px] max-w-[480px] md:max-w-[1240px]",
    sectorContainerVerticalPadding: "py-[40px] md:py-[75px]",
  }

  const BaseView = (props) => {
    return (
      <div className="pb-[150px]">
        <div id="header-title" className="w-full md:min-w-[1240px] flex flex-col md:flex-row-reverse">
          <div className="relative aspect-[375/100] md:aspect-auto w-full h-auto md:h-[360px]">
            <img
              className="absolute w-full h-full object-cover"
              src={IMG_HEADER}
              alt="seeding-intro-header"
            />
          </div>
          <div className="py-[14px] w-full md:w-[577px] flex justify-center items-center bg-[#FF0099]">
            <p className="text-[24px] md:text-[46px] text-white font-bold text-center">
              <span>
                {`商品提供`}
              </span>
              <br className="hidden md:block"/>
              <span>
                {`サービス`}
              </span>
            </p>
          </div>
        </div>
  
        <div id="header-content" className="bg-white">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
          ])}>
            <p className="whitespace-pre-wrap text-center text-[20px] md:text-[38px] font-bold">
              {[
                `インフルエンサーに商品を提供し`,
                `コンテンツを作成してみてください`
              ].join('\n')}
            </p>
            <p className="mt-[13px] md:mt-[16px] text-center text-[16px] md:text-[22px]">
              {`クオリティーの高い商品を作成いたします。`}
            </p>
  
            <div className="mt-[26px] md:mt-[40px] flex flex-col md:flex-row justify-center items-center gap-[22px] md:gap-[65px]">
              <ButtonCommonJapan
                renderContent={() => (
                  <span className="text-[20px] md:text-[22px] font-bold text-white">
                    {`紹介書ダウンロード`}
                  </span>
                )}
                onClick={openPDF}
                containerClass="w-[296px] md:w-[335px] px-[16px] py-[14px] md:py-[16px]"
                iconContainerClass="right-[14px] md:right-[16px]"
                iconClass="w-[24px] md:w-[28px] h-[24px] md:h-[28px]"
              />
              <ButtonCommonJapan
                renderContent={() => (
                  <span className="text-[20px] md:text-[22px] font-bold text-white">
                    {`はじめる`}
                  </span>
                )}
                href="/campaigns"
                containerClass="w-[296px] md:w-[335px] px-[16px] py-[14px] md:py-[16px]"
                iconContainerClass="right-[14px] md:right-[16px]"
                iconClass="w-[24px] md:w-[28px] h-[24px] md:h-[28px]"
              />
            </div>
          </div>
        </div>
        <div id="sector-1" className="bg-[#F5F5F5]">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col md:flex-row gap-[15px] md:gap-[45px]"
          ])}>
            <div className="md:w-1/2 flex flex-col justify-center">
              <p className="text-[20px] md:text-[38px] font-bold">
                <span>
                  {`知名度のあるブランドは`}
                </span>
                <br />
                <span className="text-[#FF0099]">
                  {`既にKYOLOOKを利用しています`}
                </span>
              </p>
              <p className="mt-[9px] md:mt-[17px] text-[16px] md:text-[20px]">
                {`KYOLOOKを通して継続してコンテンツを生産しています。`}
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center">
              <img
                alt="seeding-intro-01-m"
                className="w-full h-full md:hidden"
                src={IMG_SEEDING_INTRO_01_M}
              />
              <img
                alt="seeding-intro-01"
                className="w-full h-full hidden md:block"
                src={IMG_SEEDING_INTRO_01}
              />
            </div>
          </div>
        </div>


        <div id="sector-2" className="bg-white">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col gap-[19px] md:gap-[42px]"
          ])}>
            <p className="text-center text-[20px] md:text-[38px] font-bold">
              <span className="text-[#FF0099]">
                {`たった5分で完了する`}
              </span>
              <br className="block md:hidden"/>
              <span>
                {`奇跡の商品提供プロセス`}
              </span>
            </p>

            <div>
              <img
                alt="seeding-intro-02-m"
                className="w-full h-full md:hidden"
                src={IMG_SEEDING_INTRO_02_M}
              />
              <img
                alt="seeding-intro-02"
                className="w-full h-full hidden md:block"
                src={IMG_SEEDING_INTRO_02}
              />
            </div>
          </div>
        </div>


        <div id="sector-3" className="bg-[#F5F5F5]">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col md:flex-row-reverse gap-[15px] md:gap-[58px]"
          ])}>
            <div className="md:w-1/2 flex flex-col justify-center">
              <p className="text-[20px] md:text-[38px] font-bold">
                <span className="text-[#FF0099]">
                  {`500名のインフルエンサーが`}
                </span>
                <br />
                <span>
                  {`利用しています`}
                </span>
              </p>
              <p className="mt-[9px] md:mt-[17px] text-[16px] md:text-[20px] whitespace-pre-wrap">
                {[
                  `フェミニン/カジュアル/ストリートなど、`,
                  `どんなスタイルにも対応可能です。`,
                ].join('\n')}
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center">
              <img
                alt="seeding-intro-03-m"
                className="w-full h-full md:hidden"
                src={IMG_SEEDING_INTRO_03_M}
              />
              <img
                alt="seeding-intro-03"
                className="w-full h-full hidden md:block"
                src={IMG_SEEDING_INTRO_03}
              />
            </div>
          </div>
        </div>


        <div id="sector-4" className="bg-white">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col md:flex-row gap-[51px] md:gap-[52px]"
          ])}>
            <div className="md:w-1/2 flex flex-col justify-center">
              <p className="text-[20px] md:text-[38px] font-bold">
                <span className="text-[#FF0099]">
                  {`お好みのインフルエンサーにだけ`}
                </span>
                <br />
                <span>
                  {`商品を提供してください`}
                </span>
              </p>
              <p className="mt-[9px] md:mt-[17px] text-[16px] md:text-[20px] whitespace-pre-wrap">
                {[
                  `500名のインフルエンサーのうち、自社のブランドの`,
                  `イメージに合うインフルエンサーの選択が可能です。`,
                ].join('\n')}
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center">
              <img
                alt="seeding-intro-04-m"
                className="w-full h-full md:hidden"
                src={IMG_SEEDING_INTRO_04_M}
              />
              <img
                alt="seeding-intro-04"
                className="w-full h-full hidden md:block"
                src={IMG_SEEDING_INTRO_04}
              />
            </div>
          </div>
        </div>


        <div id="sector-5" className="bg-[#F5F5F5]">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col md:flex-row-reverse gap-[27px] md:gap-[60px]"
          ])}>
            <div className="md:w-1/2 flex flex-col justify-center">
              <p className="text-[20px] md:text-[38px] font-bold">
                <span>
                  {`詳細なガイドラインを`}
                </span>
                <br />
                <span>
                  {`設定してください`}
                </span>
              </p>
              <p className="mt-[9px] md:mt-[17px] text-[16px] md:text-[20px] whitespace-pre-wrap">
                {[
                  `ブランドが直接ガイドラインを設定することができます。`,
                ].join('\n')}
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center">
              <img
                alt="seeding-intro-05-m"
                className="w-full h-full md:hidden"
                src={IMG_SEEDING_INTRO_05_M}
              />
              <img
                alt="seeding-intro-05"
                className="w-full h-full hidden md:block"
                src={IMG_SEEDING_INTRO_05}
              />
            </div>
          </div>
        </div>


        <div id="sector-6" className={classNames([
          CLASS_MAP.sectorContainerVerticalPadding,
          "bg-white"
        ])}>
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            "flex flex-col md:flex-row gap-[27px] md:gap-[57px]"
          ])}>
            <div id="sector-6-1" className="md:w-1/2 flex flex-col justify-center">
              <p className="text-[20px] md:text-[38px] font-bold">
                <span>
                  {`コンテンツの2次利用は`}
                </span>
                <br />
                <span className="text-[#FF0099]">
                  {`無制限無料`}
                </span>
              </p>
              <p className="mt-[9px] md:mt-[17px] text-[16px] md:text-[22px] whitespace-pre-wrap">
                <span>
                  {`お望みの用途で期間の制限なし・無料で利用`}
                </span>
                <br className="block md:hidden"/>
                <span>
                  {`することができます。`}
                </span>
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center">
              <img
                alt="seeding-intro-06-m"
                className="w-full h-full md:hidden"
                src={IMG_SEEDING_INTRO_06_M}
              />
              <img
                alt="seeding-intro-06"
                className="w-full h-full hidden md:block"
                src={IMG_SEEDING_INTRO_06}
              />
            </div>
          </div>
          
          <div id="sector-6-2" className={classNames([
            CLASS_MAP.sectorContainerBase,
            "mt-[26px] md:mt-[56px]",
            "grid grid-cols-1 md:grid-cols-2 gap-x-0 md:gap-x-[58px] gap-y-[20px] md:gap-y-[33px]"
          ])}>
            {[
              {title: `原本ダウンロード可能`   , description: `即日ダウンロードすることができるので、メールにて原本転送依頼をする必要がありません。`},
              {title: `著作権・肖像権の問題なし`, description: (
                <>
                  <span>{`InstagramとKYOLOOKアプリの両方に投稿をし、アプリに投稿をするときに`}</span>
                  <br className="hidden md:block" />
                  <span>{`著作権・肖像権の同意を受けます。`}</span>
                </>
              )},
              {title: `高画質写真`         , description: `Instagramの投稿をスクリーンショットした写真ではなく原本写真を受け取るため、高画質でのダウンロードが可能です。`},
              {title: `2次利用無制限無料`    , description: `写真はパフォーマンスマーケティング、meta広告、商品詳細ページなどに無制限無料で利用が可能です。`},
            ].map((datum, i) => {
              return (
                <div key={`sector-6-2-${i}`}>
                  <div className="text-[20px] md:text-[22px] text-[#FF0099] font-bold">
                    {datum.title}
                  </div>
                  <div>{datum.description}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="relative select-none">
      <BaseView />

      <motion.div
        className="fixed bottom-0 left-0 right-0 md:mb-[40px]"
        variants={footerAnimVariants}
        initial={"hidden"}
        animate={showFloatingButtons ? "show" : "hidden"}
        transition={{ type: "just" }}
      >
        <div className="flex flex-row cursor-pointer mt-[-1px] justify-center items-center border-t border-[#E8E8E8] md:border-0 md:gap-[12px]">
          <div
            className="bg-[#000000] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px]  break-keep max-h-[60px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              openPDF()
            }}
          >
            <span className="text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_common_text_19}
            </span>
          </div>
          <div
            className="bg-[#FF0099] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              navigate(ROUTES.CAMPAIGN_INDEX.PATH)
            }}
          >
            <span className="text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_common_text_20}
            </span>
          </div>
        </div>
      </motion.div>
    </div>
  )
}


export default connect(mapStateToProps, mapDispatchProps)(CampaignIntroJapan)